import { Component } from '@angular/core';
import { SpinnerComponent } from '../../components/spinner/spinner.component';

/**
 * Component for loading screen
 */
@Component({
  standalone: true,
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrl: './loading-screen.component.scss',
  imports: [SpinnerComponent],
})
export class LoadingScreenComponent {}
